import logo from "../../../assets/images/icons/dome_care_logo2.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GeneralImage } from "../../../components";
import { GetArticles } from "../../../interface/GeneralResponse";
import { formatDateTimeToShow } from "../../../utils/utils";
interface InspectedArticleCardProps {
  item?: GetArticles;
}
function InspectedArticleCard({ item }: InspectedArticleCardProps) {
  const { t } = useTranslation();
  return (
    <div className="flex h-full rounded-lg p-3">
      <Link
        to={`/articles/${item?.Id}/${item?.Title}`}
        className="flex flex-col gap-2"
      >
        <GeneralImage
          src={item?.Image}
          alt={item?.Title}
          className="h-[131px] w-full rounded-lg object-cover"
          width="100%"
        />
        <h1 className="line-clamp-2 text-sm font-bold">{item?.Title}</h1>
        <p className="text-body-text line-clamp-2 text-xs">
          {item?.Description}
        </p>
        <hr />
        <div className="flex items-center gap-2">
          <img src={logo} alt="dome-care" className="h-8 w-8 rounded-full" />
          <div className="text-xs">
            <p className="font-bold">{t("app_name")}</p>
            <p className="text-body-text">
              {item?.Date ? formatDateTimeToShow(item?.Date) : ""}
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default InspectedArticleCard;
